import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function MagAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/mag/analytics").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="p-8 text-sm text-ink-muted">Loading…</div>;
  const maxDay = Math.max(1, ...data.views_by_day.map((d) => d.views));
  return (
    <div className="space-y-5" data-testid="mag-analytics">
      <h1 className="font-display text-2xl font-bold">Magazine Analytics</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="rounded-xl border border-line bg-bg-surface p-4">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-3">Views — last 30 days</div>
          <div className="flex items-end gap-1 h-28">
            {data.views_by_day.map((d) => (
              <div key={d.day} title={`${d.day}: ${d.views}`} className="flex-1 bg-brand-amber/70 rounded-t"
                style={{ height: `${Math.max(4, (d.views / maxDay) * 100)}%` }} />
            ))}
            {!data.views_by_day.length && <div className="text-xs text-ink-muted">No views recorded yet.</div>}
          </div>
        </div>
        <div className="rounded-xl border border-line bg-bg-surface p-4">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-3">Traffic Sources</div>
          {Object.entries(data.sources).map(([s, n]) => (
            <div key={s} className="flex justify-between text-sm py-1 border-b border-line/50"><span className="capitalize">{s}</span><span className="font-mono">{n}</span></div>
          ))}
          {!Object.keys(data.sources).length && <div className="text-xs text-ink-muted">No traffic yet.</div>}
        </div>
        <div className="rounded-xl border border-line bg-bg-surface p-4">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-3">Most Viewed Articles</div>
          {data.top_articles.map((a, i) => (
            <div key={a.article_id} className="flex items-center gap-2 text-sm py-1.5 border-b border-line/50">
              <span className="font-mono text-ink-muted w-5">{i + 1}.</span>
              <span className="flex-1 truncate">{a.title}</span>
              <span className="font-mono text-xs text-ink-muted">{a.views} views · {a.reading_time} min read</span>
            </div>
          ))}
        </div>
        <div className="rounded-xl border border-line bg-bg-surface p-4">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-3">Popular Categories</div>
          {data.popular_categories.map(([name, v]) => (
            <div key={name} className="flex justify-between text-sm py-1 border-b border-line/50"><span>{name}</span><span className="font-mono">{v}</span></div>
          ))}
          {!data.popular_categories.length && <div className="text-xs text-ink-muted">No category views yet.</div>}
          <div className="mt-3 text-xs font-mono text-ink-muted">Total published: {data.total_published}</div>
        </div>
      </div>
    </div>
  );
}
